/**
 * Optimizes image URLs for better performance
 * - Adds Cloudinary transforms (f_auto, q_auto) for automatic format and quality
 * - Optionally adds width parameter for responsive images
 */
export const optimizeImageUrl = (url, options = {}) => {
  if (!url) return url;
  
  const { width, quality = 'auto' } = options;
  
  // Handle Cloudinary URLs
  if (url.includes('res.cloudinary.com')) {
    // Check if transforms already exist
    if (url.includes('/f_auto') || url.includes('/q_auto')) {
      return url;
    }
    
    // Build transform string
    let transforms = `f_auto,q_${quality}`;
    if (width) {
      transforms += `,w_${width}`;
    }
    
    // Insert transforms after /upload/
    return url.replace('/upload/', `/upload/${transforms}/`);
  }
  
  // Handle Unsplash URLs - add width and quality params
  if (url.includes('unsplash.com')) {
    const separator = url.includes('?') ? '&' : '?';
    let params = `${separator}auto=format&q=80`;
    if (width) {
      params += `&w=${width}`;
    }
    // Avoid duplicate params
    if (!url.includes('auto=format')) {
      return url + params;
    }
  }
  
  return url;
};

export default optimizeImageUrl;
